import { render, staticRenderFns } from "./ConsultService.vue?vue&type=template&id=248f1d7d&scoped=true&"
import script from "./ConsultService.vue?vue&type=script&lang=js&"
export * from "./ConsultService.vue?vue&type=script&lang=js&"
import style0 from "./ConsultService.vue?vue&type=style&index=0&id=248f1d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f1d7d",
  null
  
)

export default component.exports